import type { GridAssertions } from "@/features/fields-grid";
import type { RelationshipAssertion } from "@/entities/form-metadata";
import type { GridSpan } from "@/shared/components/Grid";

interface GridLayoutConfig {
    fieldsetLabel: GridSpan;
    assertions: GridAssertions<RelationshipAssertion>;
}

export const RELATIONSHIP_GRID_LAYOUT: GridLayoutConfig = {
    fieldsetLabel: 2,
    assertions: {
        desktop: { GivenName: 6, Surname: 6 },
        tablet: { GivenName: 12, Surname: 12 },
        mobile: { GivenName: 12, Surname: 12 },
    },
};

export const HISPANIC_RELATIONSHIP_GRID_LAYOUT: GridLayoutConfig = {
    fieldsetLabel: 2,
    assertions: {
        desktop: { GivenName: 4, Surname: 4, SecondSurname: 4 },
        tablet: { GivenName: 12, Surname: 12, SecondSurname: 12 },
        mobile: { GivenName: 12, Surname: 12, SecondSurname: 12 },
    },
};
